var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-bill-back',{staticClass:"pt-bill-back__withData"})
}
var staticRenderFns = []

export { render, staticRenderFns }